const ITEMS = [
  "Sai Mohan Constructions",
  "Precision Engineering",
  "Cost-Effective Construction",
  "Structural Strength",
  "On-Time Handover",
];

const MarqueeRow = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display font-bold tracking-tight text-2xl md:text-4xl text-prussian px-6 md:px-10 whitespace-nowrap">
          {item}
        </span>
        <span className="text-blueprint-accent text-lg md:text-2xl" aria-hidden>✦</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section data-testid="editorial-marquee" className="border-y border-slate-200 bg-white py-6 md:py-8 overflow-hidden">
    <div className="flex w-max animate-marquee">
      <MarqueeRow />
      <MarqueeRow />
    </div>
  </section>
);

export default Marquee;
